﻿import React from "react";
import { useActivitiesData } from "./ActivitiesDataContext";

const WeeklyDecisionTile = {
    fields: {
        label: { type: "text" as const },
    },
    defaultProps: {
        label: "Weekly Decision",
    },
    inline: true,
    render: (props: any) => {
        const { label, puck } = props as any;
        const { weekReport, helpers } = useActivitiesData();
        const grad = helpers.gradientClass((weekReport?.decisionFlag ?? 0) as any);
        const band = helpers.bandLabel((weekReport?.decisionFlag ?? 0) as any);
        return (
            <div ref={puck.dragRef} className={`${grad} rounded-lg p-5 text-white`}>
                <div className="text-xl font-semibold">{band}</div>
                <div className="opacity-90">{label}</div>
            </div>
        );
    },
};

export default WeeklyDecisionTile;
